export default __webpack_public_path__ + "static/media/unlock.2e6f6bca.svg";